import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn, signUp } from '../lib/api';
import { Button, Input, Toast } from '../components/ui/UI';

export default function AuthPage() {
  const [mode, setMode] = useState('login'); // 'login' | 'register'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const navigate = useNavigate();

  async function handleSubmit() {
    if (!email || !password) return;
    setLoading(true);
    try {
      if (mode === 'login') {
        await signIn(email, password);
        navigate('/');
      } else {
        if (!username) { setToast({ message: 'Choisissez un pseudo.', type: 'error' }); setLoading(false); return; }
        await signUp(email, password, username);
        setToast({ message: 'Compte créé ! Vérifiez votre email si nécessaire.', type: 'success' });
        setTimeout(() => navigate('/'), 2000);
      }
    } catch (err) {
      setToast({ message: err.message, type: 'error' });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #FFF0F1 0%, #FFF8F0 50%, #F0F8FF 100%)', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: 420, animation: 'slideUp 0.4s ease' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 52, marginBottom: 12 }}>🍜</div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 28, color: 'var(--brand)', marginBottom: 6 }}>Foodies</h1>
          <p style={{ color: 'var(--text-3)', fontSize: 15 }}>Vos restaurants préférés, partagés.</p>
        </div>

        <div style={{ background: 'var(--surface)', borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow-lg)', overflow: 'hidden' }}>

          {/* Tabs */}
          <div style={{ display: 'flex', borderBottom: '1px solid var(--border)' }}>
            {[{ v: 'login', l: 'Connexion' }, { v: 'register', l: 'Inscription' }].map(t => (
              <button key={t.v} onClick={() => setMode(t.v)} style={{
                flex: 1, padding: '16px', fontSize: 15, fontWeight: 700,
                fontFamily: 'var(--font-display)',
                background: mode === t.v ? 'var(--surface)' : 'var(--surface-2)',
                color: mode === t.v ? 'var(--brand)' : 'var(--text-3)',
                borderBottom: mode === t.v ? '2px solid var(--brand)' : '2px solid transparent',
                border: 'none', cursor: 'pointer', transition: 'all 0.2s',
              }}>{t.l}</button>
            ))}
          </div>

          {/* Form */}
          <div style={{ padding: '28px', display: 'flex', flexDirection: 'column', gap: 16 }}>
            {mode === 'register' && (
              <Input label="Pseudo" value={username} onChange={e => setUsername(e.target.value)} placeholder="Ex : MaxFoodies" icon="👤" />
            )}
            <Input label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="vous@email.com" icon="✉️"
              onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
            <Input label="Mot de passe" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" icon="🔒"
              onKeyDown={e => e.key === 'Enter' && handleSubmit()} />

            <Button onClick={handleSubmit} loading={loading} fullWidth size="lg" style={{ marginTop: 4 }}>
              {mode === 'login' ? '🚀 Se connecter' : '✨ Créer mon compte'}
            </Button>

            {mode === 'login' && (
              <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-3)' }}>
                Pas encore de compte ?{' '}
                <span onClick={() => setMode('register')} style={{ color: 'var(--brand)', fontWeight: 600, cursor: 'pointer' }}>S'inscrire</span>
              </p>
            )}
          </div>
        </div>

        <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--text-3)', marginTop: 20 }}>
          Partagez vos découvertes culinaires avec vos proches 🍽️
        </p>
      </div>

      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
}
